import { render, staticRenderFns } from "./StoriesArticleIllustratedMainCopy.vue?vue&type=template&id=2e303980&scoped=true&"
import script from "./StoriesArticleIllustratedMainCopy.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleIllustratedMainCopy.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleIllustratedMainCopy.vue?vue&type=style&index=0&id=2e303980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e303980",
  null
  
)

export default component.exports